import { Icon, Pill } from '@iwoca/orion';
import classNames from 'classnames';

import styles from './TradingHistoryLoanSummary.module.css';
import { displayCurrency } from '../../../utils/DisplayCurrency';
import { ProbabilityOfOffer } from '../types';

const TradingHistoryLoanSummary = ({
    amount,
    probabilityOfOffer,
    isInSplitTestHighProbability,
    isInSplitInterestOnly,
    requestedAmount,
    offerType,
    productType
}: {
    amount: string;
    isPartnerCustomer: boolean;
    probabilityOfOffer: ProbabilityOfOffer;
    isInSplitTestHighProbability: boolean;
    isInSplitInterestOnly: boolean;
    requestedAmount: number;
    offerType?: string;
    productType: 'credit_facility' | 'flexi24';
}) => {
    function EstimatedAmountText() {
        const estimatedAmount = parseInt(amount);

        if (estimatedAmount < requestedAmount) {
            return (
                <li>
                    <div>
                        <Icon icon="pound" /> Your requested amount{' '}
                    </div>
                    <span>{displayCurrency(requestedAmount)}</span>
                </li>
            );
        }
        return (
            <li>
                <div>
                    <Icon icon="pound" /> Estimated amount{' '}
                </div>
                <span>{displayCurrency(parseInt(amount))}</span>
            </li>
        );
    }

    return (
        <article className={styles.article}>
            <div className={styles.panel}>
                <div className={styles.offerHeader}>
                    {productType === 'credit_facility' && (
                        <h3>You're eligible for our Flexi loan*</h3>
                    )}
                    {productType === 'flexi24' && (
                        <h3>You're eligible for our Flexi-24 loan*</h3>
                    )}
                    {probabilityOfOffer === 'high_probability_of_offer' &&
                        isInSplitTestHighProbability && (
                            <span>
                                <Pill variant="green" size="small">
                                    High chance of approval
                                </Pill>
                            </span>
                        )}
                </div>
                <div className={styles.offerBody}>
                    <div className={styles.offerFeatures}>
                        {
                            <ul>
                                <li>
                                    <Icon icon="starOutline" />
                                    Repay early for free
                                </li>

                                <li>
                                    <Icon icon="clockOutline" /> Decision in 24
                                    hours
                                </li>
                            </ul>
                        }
                    </div>
                    <div className={styles.offerDetails}>
                        <ul>
                            <li>
                                <Icon icon="calendarOutline" /> Borrow from 1
                                day to 24 months
                            </li>

                            {offerType === 'confirmed' ? (
                                <li>
                                    <div>
                                        <Icon icon="pound" /> Confirmed borrow
                                        amount{' '}
                                    </div>
                                    <span>
                                        {displayCurrency(parseInt(amount))}
                                    </span>
                                </li>
                            ) : (
                                <EstimatedAmountText />
                            )}
                        </ul>
                    </div>
                    {isInSplitInterestOnly && (
                        <div
                            className={classNames(
                                styles.offerDetails,
                                styles.extraInfo
                            )}>
                            <ul>
                                <li>
                                    <Icon icon="exchange" /> 3-month
                                    interest-only repayment option
                                </li>
                            </ul>
                        </div>
                    )}

                    <div
                        className={classNames(
                            styles.offerDetails,
                            styles.summaryTerms
                        )}>
                        <ul>
                            <li>
                                *Final terms are subject to the strength of your
                                application
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default TradingHistoryLoanSummary;
